module.exports = __webpack_public_path__ + "static/media/printlogo.e4678632.svg";